import { Component, Input, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SagaObject } from '@models/imported/SagaBase/SagaObject';
import { CacheService } from '@services/cache/cache.service';
import { Subscription } from 'rxjs';

@Component({
  templateUrl: 'object-chooser.component.html',
  styleUrls: ['object-chooser.component.scss']
})
export class ObjectChooserComponent implements OnDestroy {
  @Input()
  objects: SagaObject[];

  private readonly sub: Subscription;

  constructor(private modal: ModalController, private cache: CacheService) {
    this.sub = this.cache.onChange.subscribe(() => {
      this.objects = this.objects.filter(o => this.cache.getObjectByUid(o.ObjGuid));
    });
  }

  selectObject(object: SagaObject) {
    this.modal.dismiss(object);
  }

  cancel() {
    this.modal.dismiss();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
